import { Box, styled } from '@mui/material';
import { Tags, ContactName } from './components';
import { IContactTag, IContact, IBusiness } from '@trii/types/dist/Contacts/contacts';
import AvatarWithActions from './components/AvatarWithActions/AvatarWithActions';
import type { ChangeEvent, RefObject } from 'react';

const HeaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '4px',
  marginBottom: '20px',
  position: 'relative',
});

type HeaderProps = {
  imgUrl?: string;
  displayName: string;
  onError?: (error: Error) => void;
  tags: IContactTag[];
  onEditTags: () => void;
  onUploadPhoto: () => void;
  onPhotoFileChange: (event: ChangeEvent<HTMLInputElement>) => void;
  photoInputRef: RefObject<HTMLInputElement>;
  isUploadingPhoto: boolean;
  onDeletePhoto: () => void;
  isDeletingPhoto: boolean;
  contactType?: 'contact' | 'business' | 'unknown';
  firstName?: string;
  lastName?: string;
  name?: string;
  entityId?: string;
  onEntityUpdated?: (data: IContact | IBusiness) => void;
};

const Header = ({
  imgUrl,
  displayName,
  onError,
  tags,
  onEditTags,
  onUploadPhoto,
  onPhotoFileChange,
  photoInputRef,
  isUploadingPhoto,
  onDeletePhoto,
  isDeletingPhoto,
  contactType,
  firstName,
  lastName,
  name,
  entityId,
  onEntityUpdated,
}: HeaderProps) => {
  const avatarAlt = `Avatar for ${displayName}`;

  return (
    <HeaderContainer>
      <input
        ref={photoInputRef}
        type="file"
        accept="image/*"
        onChange={onPhotoFileChange}
        style={{ display: 'none' }}
      />
      <AvatarWithActions
        src={imgUrl}
        alt={avatarAlt}
        onError={() => onError?.(new Error('Failed to load avatar'))}
        onUpload={onUploadPhoto}
        isUploading={isUploadingPhoto}
        onDelete={onDeletePhoto}
        isDeleting={isDeletingPhoto}
      />

      <ContactName
        displayName={displayName}
        contactType={contactType}
        firstName={firstName}
        lastName={lastName}
        name={name}
        entityId={entityId}
        onEntityUpdated={onEntityUpdated}
      />
      <Tags tags={tags} onEditTags={onEditTags} />
    </HeaderContainer>
  );
};

export default Header;
